import { create } from "zustand";

interface PropertyModalState {
  showPropertyModal: boolean;
  listingId: string | null;
  setShowPropertyModal: (show: boolean, listingId?: string) => void;
  resetPropertyModal: () => void;
}

export const usePropertyModalStore = create<PropertyModalState>((set) => ({
  showPropertyModal: false,
  listingId: null,
  setShowPropertyModal: (show, listingId) => {
    if (show && !listingId) {
      return;
    }
    set({
      showPropertyModal: show,
      listingId: show ? (listingId ?? null) : null,
    });
  },
  resetPropertyModal: () => set({ showPropertyModal: false, listingId: null }),
}));
